import { render, staticRenderFns } from "./DetailsInfo.vue?vue&type=template&id=7ef97d51&scoped=true&"
import script from "./DetailsInfo.vue?vue&type=script&lang=js&"
export * from "./DetailsInfo.vue?vue&type=script&lang=js&"
import style0 from "./DetailsInfo.vue?vue&type=style&index=0&id=7ef97d51&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ef97d51",
  null
  
)

export default component.exports